<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiPlay } from "@mdi/js";
export default {
  name: "MdiPlay",
  data() {
    return {
      svgPath: mdiPlay,
    };
  },
};
</script>
